import { useEffect, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";

export default function EquipmentPercentageField({ fraction, onFractionChange, onBlur, ...props }) {
  const [text, setText] = useState(() => fraction === "" || fraction == null ? "" : String(Number((Number(fraction) * 100).toPrecision(12))));
  useEffect(() => {
    setText(previous => {
      if (fraction === "" || fraction == null) return "";
      if (previous !== "" && Math.abs(Number(previous) / 100 - Number(fraction)) < 1e-12) return previous;
      return String(Number((Number(fraction) * 100).toPrecision(12)));
    });
  }, [fraction]);
  return <TextField {...props} type="text" inputMode="decimal" value={text}
    onBlur={onBlur} onChange={event => {
      const raw = event.target.value.replace(",", ".");
      if (!/^\d*\.?\d*$/.test(raw)) return;
      setText(raw);
      onFractionChange(raw === "" || raw === "." ? "" : String(Number(raw) / 100));
    }} InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }} />;
}
